import { CustomFieldValue } from '@integration-frontends/integration/core/model';

export interface AssetCustomFieldValue extends CustomFieldValue {
  assetId: string;
}
